import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link, useRouteMatch } from 'react-router-dom';
import { BASE_SHIPMENTS_PATH, BATCHES_PATH } from '../../../../../routes/constants';

import style from '../../../batch-components.module.less';

const BatchName = ({ name = '', className = '', fulfillmentPlanSetId = 0 }) => {
  const match = useRouteMatch();

  return (
    <div className={classnames(style.name, className, style['name-title'])}>
      <Link to={`${BASE_SHIPMENTS_PATH}${BATCHES_PATH}/${match.params.tabFilter || 'open'}/${fulfillmentPlanSetId}`}>{name}</Link>
    </div>
  );
};

BatchName.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  fulfillmentPlanSetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BatchName;
